import React from 'react';
import { Box } from '@chakra-ui/react';
import Navbar from '../components/Navbar';
import HeroSection from '../components/sections/HeroSection';
import ReframeSection from '../components/sections/ReframeSection';
import HowItWorksSection from '../components/sections/HowItWorksSection';
import ExponentialSection from '../components/sections/ExponentialSection';
import LearningSection from '../components/sections/LearningSection';
import InfrastructureSection from '../components/sections/InfrastructureSection';
import InvestorThesisSection from '../components/sections/InvestorThesisSection';
import VisionSection from '../components/sections/VisionSection';
import FooterSection from '../components/sections/FooterSection';
import OriginSection from '../components/sections/OriginSection';
import MoatSection from '../components/sections/MoatSection';



export default function HomePage() {
  return (
    <Box as="main" bg="bg.900" minH="100vh">
      <Navbar />
      <HeroSection />
      <ReframeSection />
      <HowItWorksSection />
      <ExponentialSection />
      <MoatSection />   
      <LearningSection />
      <InfrastructureSection />
      <InvestorThesisSection />
      <OriginSection />
      <VisionSection />
      <FooterSection />
    </Box>
  );
}
